import React from 'react'
import { withNamespaces } from 'react-i18next'
import {
    Modal, 
    ModalHeader, 
    ModalBody, 
    ModalFooter,
    Button, 
    Spinner
} from 'reactstrap'

const StatusChangeConfirmModal = ({ 
    show, 
    toggle, 
    onConfirm,
    inProcess,
    t
}) => {
    const handleConfirm = () => {
        onConfirm()
    }

    return (
        <Modal isOpen={show} toggle={toggle}>
            <ModalHeader toggle={toggle}>
                {t('The Task Has Not Started Yet')}
            </ModalHeader>
            <ModalBody>
                <p>
                    {t('This task is scheduled to start in the future. Are you sure you want to change its status now')}?
                </p>
            </ModalBody>
            <ModalFooter>
                <Button 
                    color="primary" 
                    onClick={handleConfirm}
                    disabled={inProcess}
                >
                    {inProcess && (
                        <Spinner 
                            size='sm'
                            color='white'
                            className='me-1'
                        />
                    )}
                    {t('Yes, Change Status')}
                </Button>
                <Button color="secondary" onClick={toggle}>
                    {t('Cancel')}
                </Button>
            </ModalFooter>
        </Modal>
    )
}

export default withNamespaces()(
    StatusChangeConfirmModal
)